export default "__VITE_ASSET__DARVCePj__"